
/**
 * 判断试题是否显示
 * @param condition 条件str
 * @param list 试题list
 * @return Boolean
 */
export const IsShow = (list, condition) => {
    if (!condition) return false
    let result = false
    let codeAndRow = condition.split(':')[0] // 试题号、行号
    let code = codeAndRow.split('_')[0] // 试题编码
    list.forEach(item => {
        if (code == item.quesCode) {
            result = item.isShow && item.bindIsShow
        }
    });
    return result;
}

